// TODO: this should be in it's own package (Copied from RosterFrontEndStaticWebsiteReact)
import {
  configureStore,
  createSerializableStateInvariantMiddleware,
  AnyAction,
} from "redux-starter-kit";
import { EnhancedStore } from "redux-starter-kit/src/configureStore";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { createLogicMiddleware } from "redux-logic";
import { History } from "history";
import rootReducer, { RootState } from "./rootReducer";
import rootLogic from "./rootLogic";
import { reduxErrorMiddleware } from "../logging";
import reduxRouterRedirectMiddleware from "./routerRedirect/reduxRouterRedirectMiddleware";

export default function configureAppStore(
  initialState: Partial<RootState> | undefined,
  routerHistory: History,
  logLogic?: boolean
): EnhancedStore<RootState, AnyAction> {
  const isProduction = process.env.NODE_ENV === "production";

  const logicMiddleware = createLogicMiddleware(rootLogic);

  if (logLogic) {
    logicMiddleware.monitor$.subscribe((x) => console.log(x));
  }

  const middleware = isProduction
    ? [
        reduxErrorMiddleware,
        logicMiddleware,
        reduxRouterRedirectMiddleware(routerHistory),
      ]
    : [
        reduxErrorMiddleware,
        reduxRouterRedirectMiddleware(routerHistory),
        logicMiddleware,
        createSerializableStateInvariantMiddleware(),
        reduxImmutableStateInvariant(),
      ];

  const store = configureStore({
    middleware,
    reducer: rootReducer,
    devTools: !isProduction,
    preloadedState: initialState,
  });

  // Enables hot reloading of reducers.
  if (!isProduction && (module as any).hot) {
    (module as any).hot.accept("./rootReducer", () =>
      store.replaceReducer(rootReducer)
    );
  }

  return store;
}
